import PageHeader from "app/shared/PageHeader";
import VAT from "./Vat";
import DashboardVAT from "./components/Dashboard";
import DocumentTracker from "./components/DocumentTracker";
import TaxOffice from "./components/Tax Office";
import IdeationPortal from "./components/Ideation Portal";
import VATPotential from "./components/Analysis/components/VAT Potential";
import Recovery from "./components/Analysis/components/Recovery";
import Submission from "./components/Analysis/components/Submission";
import InvoiceCompliance from "./components/Analysis/components/Invoice Incompliance";
import Applications from "./components/Details/components/Applications";
import Transactions from "./components/Details/components/Transactions";
import SavedReport from "./components/Details/components/SavedReport";
import PreviousExport from "./components/Details/components/PreviousExport";
import Entities from "./components/Details/components/Entities";
import GovernmentRules from "./components/GovernmentRules";


//eslint-disable-next-line
export default {
  path: "/VAT/",
  element: <VAT/>,
  strict: true,
  children: [
    {
      path: "/VAT/dashboard",
      element: <DashboardVAT/>,
      exact: true,
    },
    {
      path: "/VAT/documentTracker",
      element: <DocumentTracker/>,
      exact: true,
    },
    {
      path: "/VAT/taxOffice",
      element: <TaxOffice/>,
      exact: true,
    },
     {
      path: "/VAT/ideationPortal",
      element: <IdeationPortal/>,
      exact: true,
    },
     {
      path: "/VAT/analysis/potential",
      element: <VATPotential/>,
      exact: true,
    },
    {
      path: "/VAT/analysis/recovery",
      element: <Recovery/>,
      exact: true,
    },
     {
      path: "/VAT/analysis/submission",
      element: <Submission/>,
      exact: true,
    },
    {
      path: "/VAT/analysis/invoiceCompliance",
      element: <InvoiceCompliance/>,
      exact: true,
    },
    {
      path: "/VAT/detail/applications",
      element: <Applications/>,
      exact: true,
    },
    {
      path: "/VAT/detail/transactions",
      element: <Transactions/>,
      exact: true,
    },
    {
      path: "/VAT/detail/saveReport",
      element: <SavedReport/>,
      exact: true,
    },
     {
      path: "/VAT/detail/previousExport",
      element: <PreviousExport/>,
      exact: true,
    },
     {
      path: "/VAT/detail/entities",
      element: <Entities/>,
      exact: true,
    },
    {
      path: "/VAT/governmentRules",
      element: <GovernmentRules/>,
      exact: true,
    },
  ],
};
